import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import * as Sentry from "@sentry/browser";
import ReactGA from "react-ga";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.min.css";
import "./sass/main.scss";
import { BrowserRouter } from "react-router-dom";
import mixpanel from "mixpanel-browser";

import App from "./components/App";
import store from "./store";
import ErrorBoundary from "./ErrorBoundaries";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_URL,
  release: process.env.REACT_APP_SENTRY_RELEASE,
});

mixpanel.init(process.env.REACT_APP_MIXPANEL_URI || "");

// TODO: if using Google Analytics replace react-ga library for react-ga-4 since react-ga is now archived and no longer actively maintained.
ReactGA.initialize(process.env.REACT_APP_GOOGLE_ANALYTICS_TRACKING_ID || "", {
  gaOptions: {
    siteSpeedSampleRate: 100,
  },
});

// history.listen((location) => {
//   ReactGA.set({ page: location.pathname });
//   ReactGA.pageview(location.pathname);
// });

const rootElement = document.getElementById("root") as HTMLElement;
const root = createRoot(rootElement);

root.render(
  <Provider store={store}>
    <ErrorBoundary>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ErrorBoundary>
  </Provider>
);
